import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import Get from './components/Get';
import Header from './components/Header';
import {QRCodeCanvas} from 'qrcode.react';
import {FaWhatsapp} from 'react-icons/fa';

const Qr = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [upi, setUpi] = useState('');
  const [name, setName] = useState('');
  const [txn, setTxn] = useState('');
  const qrRef = useRef(null);

  const get = () => {
    Get.Upi().then(res => {
      console.log(res);
      setUpi(res.data.upi);
      setName(res.data.name);
    });
  };

  const shareToWhatsApp = async () => {
    try {
      const canvas = qrRef.current;
      if (!canvas) return;

      const amount = location.state?.amount || 0;
      const paymentLink = `upi://pay?pa=${upi}&pn=${name}&am=${amount}&tn=${txn}&tr=${txn}`;

      // Convert canvas to blob
      canvas.toBlob(async blob => {
        const file = new File([blob], `payment-qr-${txn}.png`, {
          type: 'image/png',
        });

        // Check if Web Share API is available (works on mobile)
        if (
          navigator.share &&
          navigator.canShare &&
          navigator.canShare({files: [file]})
        ) {
          try {
            await navigator.share({
              files: [file],
              title: 'Payment QR Code',
              text: `Payment QR Code\n\nAmount: ₹${amount}\nTransaction ID: ${txn}\n\nScan to pay via UPI`,
            });
            // User will select WhatsApp from share options
          } catch (err) {
            if (err.name !== 'AbortError') {
              console.error('Share failed:', err);
              // Fallback to download + WhatsApp
              downloadAndOpenWhatsApp(blob, amount, paymentLink);
            }
          }
        } else {
          // Desktop fallback: Download QR and open WhatsApp
          downloadAndOpenWhatsApp(blob, amount, paymentLink);
        }
      });
    } catch (error) {
      console.error('Error sharing QR code:', error);
      alert('Unable to share. Please try again.');
    }
  };

  const downloadAndOpenWhatsApp = (blob, amount, paymentLink) => {
    // Download the QR code
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.download = `payment-qr-${txn}.png`;
    link.href = url;
    link.click();
    URL.revokeObjectURL(url);

    // Open WhatsApp with message
    setTimeout(() => {
      const message = `Payment QR Code Downloaded!\n\nAmount: ₹${amount}\nTransaction ID: ${txn}\n\nPayment Link:\n${paymentLink}\n\nPlease attach the downloaded QR code image.`;
      const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
      window.open(whatsappUrl, '_blank');
    }, 500);
  };

  useEffect(() => {
    // Generate random transaction ID
    let minm = 100000000000000;
    let maxm = 999999999999999;
    setTxn(Math.floor(Math.random() * (maxm - minm + 1)) + minm);
    get();
  }, []);

  const amount = location.state?.amount || 0;

  return (
    <div style={{flex: 1}}>
      <Header />
      <div style={styles.main}>
        <p style={{textAlign: 'center', marginBottom: 20, padding: 10}}>
          नोटः अब आप QR को किसी भी मोबाइल से स्कैन करके कॉइन Add कर सकते हैं।
          Add कॉइन का समय 24 घण्टे रहेगा।
        </p>

        <div style={styles.qrContainer}>
          <QRCodeCanvas
            ref={qrRef}
            value={`upi://pay?pa=${upi}&pn=${name}&am=${amount}&tn=${txn}&tr=${txn}`}
            size={260}
            level="H"
            includeMargin={true}
          />
        </div>

        <p style={{textAlign: 'center', marginTop: 30, padding: 10}}>
          नोट: किसी भी प्रकार की समस्या आने पर हेल्पलाइन नंबर पर संपर्क करें !
          धन्यवाद
        </p>
      </div>
      <div style={styles.buttonContainer}>
        <button onClick={shareToWhatsApp} style={styles.whatsappBtn}>
          <FaWhatsapp size={24} color="#fff" />
          <span style={{marginLeft: 8, color: '#fff'}}>Share on WhatsApp</span>
        </button>
      </div>

      {/* <p style={styles.instruction}>
        {navigator.share
          ? 'Tap the button above and select WhatsApp to share'
          : 'QR code will be downloaded. Attach it in WhatsApp to share.'}
      </p> */}
    </div>
  );
};

const styles = {
  main: {
    width: '90%',
    margin: '0 auto',
    minHeight: '60vh',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  qrContainer: {
    padding: '10px',
    backgroundColor: '#fff',
    borderRadius: '10px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
  },
  whatsappBtn: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#25D366',
    border: 'none',
    borderRadius: 10,
    padding: '12px 24px',
    cursor: 'pointer',
    fontSize: 16,
    fontWeight: 'bold',
    boxShadow: '0 4px 12px rgba(37, 211, 102, 0.3)',
  },
  instruction: {
    textAlign: 'center',
    fontSize: '12px',
    color: '#666',
    padding: '0 20px',
    marginTop: '10px',
  },
};

export default Qr;
